import type { PropsWithChildren } from 'react'

function EnvIndicator({ children }: PropsWithChildren): JSX.Element {
  return (
    <div
      className={`flex flex-col flex-no-wrap h-screen lg:flex-row ${CURRENT_ENV === 'dev' ? 'before:absolute before:w-full before:h-5 before:bg-green-200' : CURRENT_ENV === 'test' ? 'before:absolute before:w-full before:h-5 before:bg-orange-200' : ''}`}
    >
      {children}
    </div>
  )
}

export default EnvIndicator
